import styled from '@emotion/styled'
import { MdErrorOutline } from 'react-icons/md'

export const styledLink = styled('a')`
  label: styledLink;
  text-decoration: underline;
  font-weight: bold;
  color: ${(props) => props.theme.colors.alertRed};
  :hover {
    color: ${(props) => props.theme.colors.alertRed};
    cursor: pointer;
  }
`

export const styledAlertIcon = styled(MdErrorOutline)`
  label: styledAlertIcon;
  color: ${(props) => props.theme.colors.alertRed};
  height: 1.4em;
  width: 1.4em;
  position: absolute;
  left: 8px;
  top: 13px;
`
